<template>
    <div
        v-if="!isFetching"
        class="box box-primary"
    >
        <div
            v-if="!bodies.data.length"
            class="box-body with-border clearfix"
        >
            <p>There are no Predefined bodies in the system</p>
        </div>
        <div v-else>
            <div
                v-if="!haveCategories"
                class="box-header with-border"
            >
                <h3 class="box-title">Bodies</h3>
                <div class="box-tools pull-right">
                    <a
                        :href="'/predefined-bodies/new?category_id=' + categoryID"
                        class="btn btn-xs btn-primary inner-btn-spacing"
                        >Add New</a
                    >
                    <button
                        class="btn btn-box-tool"
                        data-toggle="tooltip"
                        data-widget="collapse"
                        title="Collapse"
                        type="button"
                    >
                        <i class="fa fa-minus"></i>
                    </button>
                </div>
            </div>
            <div
                v-else
                class="box-header with-border"
            >
                <h3 class="box-title">Predefined Bodies table</h3>
                <div class="box-tools pull-right">
                    <button
                        class="btn btn-box-tool"
                        data-toggle="tooltip"
                        data-widget="collapse"
                        title="Collapse"
                        type="button"
                    >
                        <i class="fa fa-minus"></i>
                    </button>
                </div>
            </div>
            <div
                v-if="bodies.total"
                class="box-body with-border clearfix"
            >
                <BadgeTotal
                    :value="bodies.total"
                    color="gray"
                    :label="`${$t('total')}: `"
                />

                <div
                    class="pagination-box"
                    @click="preventEnter"
                    @keydown="preventEnter"
                >
                    <pagination
                        :class="isDisabled()"
                        :data="bodies"
                        :limit="$root.paginator.settings.limit"
                        :size="$root.paginator.settings.size"
                        class="pull-right no-margin vue-pagination"
                        show-disabled
                        @pagination-change-page="getData"
                    >
                        <span slot="prev-nav">
                            <i class="fa fa-angle-double-left"></i>
                        </span>
                        <span slot="next-nav">
                            <i class="fa fa-angle-double-right"></i>
                        </span>
                    </pagination>
                </div>
            </div>
            <div class="box-body table-responsive no-padding">
                <table class="table table-hover">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th v-if="haveCategories">Category</th>
                            <th>Name</th>
                            <th>Content</th>
                            <th class="text-center">Welcome</th>
                            <th class="text-center">Campaigns</th>
                            <th class="text-center">Length</th>
                            <th>Messages</th>
                            <th>Clicks</th>
                            <th>Revenues</th>
                            <th>pCPM/eCPM/EPC</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            v-for="body in bodies.data"
                            :key="body.id"
                        >
                            <td>{{ body.id }}</td>
                            <td v-if="haveCategories">
                                <a
                                    :href="getRoute(body.category.id, 'category')"
                                    :title="body.name"
                                >
                                    {{ body.category.name }}
                                </a>
                            </td>
                            <td>{{ stringTruncate(body.name) }}</td>
                            <td>{{ body.content }}</td>
                            <td class="text-center">
                                <ValueYesNo :value="Boolean(body.welcome)" />
                            </td>
                            <td class="text-center">
                                <BadgeTotal
                                    :value="body.campaigns_count"
                                    color="gray"
                                />
                            </td>
                            <td class="text-center">
                                <BadgeTotal
                                    :color="body.length.color"
                                    :value="body.length.value"
                                />
                            </td>
                            <td>
                                <img
                                    v-show="!isLoaded"
                                    alt="Preloader"
                                    class="table-row-preloader"
                                    rel="preload"
                                    src="/img/table-row-preloader.gif"
                                />
                                <BadgeTotal
                                    v-show="isLoaded"
                                    :value="body.messages_count"
                                    color="gray"
                                    title="Total"
                                />
                                <BadgeTotal
                                    v-show="isLoaded"
                                    :value="body.messages_sent"
                                    color="green"
                                    title="Sent"
                                />
                                <BadgeTotal
                                    v-show="isLoaded"
                                    :value="body.messages_failed"
                                    color="red"
                                    title="Failed"
                                />
                                <BadgeTotal
                                    v-show="isLoaded"
                                    :value="body.messages_blacklisted"
                                    color="black"
                                    title="Blacklisted"
                                />
                            </td>
                            <td>
                                <img
                                    v-show="!isLoaded"
                                    alt="Preloader"
                                    class="table-row-preloader"
                                    rel="preload"
                                    src="/img/table-row-preloader.gif"
                                />
                                <BadgeTotal
                                    v-show="isLoaded"
                                    :value="body.percentage + '%'"
                                    color="light-blue"
                                    title="Percentage"
                                />
                                <BadgeTotal
                                    v-show="isLoaded"
                                    :value="body.clicks_count"
                                    color="aqua-active"
                                    title="Amount"
                                />
                            </td>
                            <td>
                                <img
                                    v-show="!isLoaded"
                                    alt="Preloader"
                                    class="table-row-preloader"
                                    rel="preload"
                                    src="/img/table-row-preloader.gif"
                                />
                                <BadgeTotal
                                    v-show="isLoaded"
                                    :value="'$' + body.revenues_prepared_value"
                                    color="light-blue"
                                    title="Amount"
                                />
                                <BadgeTotal
                                    v-show="isLoaded"
                                    :value="body.revenues_count"
                                    color="aqua-active"
                                    title="Count"
                                />
                            </td>
                            <td>
                                <img
                                    v-show="!isLoaded"
                                    alt="Preloader"
                                    class="table-row-preloader"
                                    rel="preload"
                                    src="/img/table-row-preloader.gif"
                                />
                                <BadgeTotal
                                    v-show="isLoaded"
                                    :value="body.pcpm_prepared_value"
                                    :color="body.pcpm_prepared_value < 0 ? 'red' : 'green'"
                                    title="pCPM"
                                />
                                <BadgeTotal
                                    v-show="isLoaded"
                                    :value="body.ecpm_prepared_value"
                                    color="light-blue"
                                    title="eCPM"
                                />
                                <BadgeTotal
                                    v-show="isLoaded"
                                    :value="body.epc_prepared_value"
                                    color="aqua-active"
                                    title="EPC"
                                />
                            </td>
                            <td class="text-right">
                                <ModalContent
                                    v-if="!body.active"
                                    :id="body.id"
                                    :active="body.active"
                                    :modal="modal"
                                    :route="route"
                                    type="active"
                                    @click="isShowModal = true"
                                />
                                <ModalContent
                                    v-else-if="body.campaigns_for_deactivation === 0"
                                    :id="body.id"
                                    :active="body.active"
                                    :modal="modal"
                                    :route="route"
                                    type="deactivate"
                                    @click="isShowModal = true"
                                />
                                <span v-if="editAvailable">
                                    <a
                                        v-show="body.campaigns_count === 0 || (body.campaigns_count === 1 && body.campaigns && body.is_editable === true)"
                                        :href="getRoute(body.id, 'edit')"
                                        class="btn btn-sm btn-primary"
                                    >
                                        <i class="fa fa-edit"></i>
                                        <span class="sr-only">Edit</span>
                                    </a>
                                </span>
                                <a
                                    :href="getRoute(body.id, 'show')"
                                    class="btn btn-sm btn-info"
                                >
                                    <i class="fa fa-eye"></i>
                                    <span class="sr-only">Show</span>
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="box-footer clearfix">
                <div
                    class="pagination-box"
                    @click="preventEnter"
                    @keydown="preventEnter"
                >
                    <pagination
                        :class="isDisabled()"
                        :data="bodies"
                        :limit="$root.paginator.settings.limit"
                        :size="$root.paginator.settings.size"
                        class="pull-right no-margin vue-pagination"
                        show-disabled
                        @pagination-change-page="getData"
                    >
                        <span slot="prev-nav">
                            <i class="fa fa-angle-double-left"></i>
                        </span>
                        <span slot="next-nav">
                            <i class="fa fa-angle-double-right"></i>
                        </span>
                    </pagination>
                </div>
            </div>
        </div>
        <!-- /.box-body -->
        <main-modal-form
            v-if="isShowModal"
            :modal="modal"
            @close="isShowModal = false"
            @updateData="modalData($event)"
        />
    </div>
</template>

<script>
import BadgeTotal from '../../subcomponents/BadgeTotal';
import ModalContent from '../../subcomponents/modals-content/ModalPredefinedBodiesContent';
import ValueYesNo from '../../subcomponents/ValueYesNo';

export default {
    components: {
        BadgeTotal,
        ModalContent,
        ValueYesNo
    },
    props: {
        route: Object,
    },
    data() {
        return {
            bodies: {},
            stats: {},
            ids: [],
            isLoaded: false,
            isFetching: true,
            disablePagination: true,
            haveCategories: this.$attrs.havecategories,
            categoryID: this.$attrs.catid,
            editAvailable: false,
            pageNumber: this.$route.query.page,
            isShowModal: false,
            modal: {
                class: 'modal-bodies',
                header: '',
                body: '',
                isBodyHtml: true,
                id: '',
                active: '',
            },
        };
    },
    mounted() {
        this.getData(this.pageNumber);
    },
    methods: {
        modalData(e) {
            this.isShowModal = false;
            _.merge(_.keyBy(this.bodies.data, 'id'), _.keyBy({ 0: e }, 'id'));
        },
        preventEnter: function (event) {
            if (this.disablePagination) {
                return event.preventDefault();
            }
        },
        getData(page = 1) {
            this.disablePagination = true;
            axios.get(this.$route.path + '/data?page=' + page).then((response) => {
                if (String(page) !== String(this.$route.query.page)) {
                    this.$router.push({ query: Object.assign({}, this.$route.query, { page: String(page) }) });
                }

                if (page > response.data.bodies.last_page) {
                    return this.getData();
                }

                this.bodies = response.data.bodies;
                this.isLoaded = false;
                this.isFetching = false;
                this.editAvailable = response.data.editAvailable;
                this.ids = response.data.ids;
                if (this.ids.length) {
                    this.getStats(this.ids);
                }
            });
        },
        getStats(ids) {
            axios.get('/predefined-bodies/stats?ids=' + ids).then((response) => {
                this.isLoaded = true;
                this.disablePagination = false;
                this.stats = response.data.stats;
                let sort = _.merge(_.keyBy(this.bodies.data, 'id'), _.keyBy(this.stats, 'id'));
                this.bodies.data = _.orderBy(sort, ['id'], ['desc']);
            });
        },
        setModalData(e) {
            this.modalData = e;
        },
        getRoute: function (id, type) {
            return this.route[type].replace(':id:', id);
        },
        isDisabled: function () {
            return this.disablePagination ? 'disabled-box' : '';
        },
        stringTruncate: function (value) {
            return _.truncate(value, { length: 20, separator: '...' });
        },
    },
};
</script>
